module.exports = __webpack_public_path__ + "static/media/photography-frame.266e91b7.svg";